<div class="footer-content">
  <div class="lqd-column col-md-6 text-left">
    <a (click)="previous()" *ngIf="canGoBack()" class="btn btn-default text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 previous">
      <span class="btn-txt" appTranslate="previous"></span>
    </a>
  </div>
  <div class="stretch"></div>
  <div>
    <a (click)="next()" [class.disabled]="!canGoNext()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-2 font-weight-bold ltr-sp-05 mb-2 next">
      <span *ngIf="!isFinalStep()" class="btn-txt" appTranslate="next"></span>
      <span *ngIf="isFinalStep()" class="btn-txt" appTranslate="sendRequest"></span>
    </a>
  </div>
</div>
